import { useSuspenseQuery } from '@tanstack/react-query';
import { userWorkspaceQueryCreator } from '@/query/userWorkspaceQueryCreator';
import type { WorkatoApp } from '../type/workato';

export type WorkatoHook = {
  workatoApps: WorkatoApp[] | null;
  isLoading: boolean;
  isError: boolean;
  error: Error | null;
  isFetched: boolean;
  isFetching: boolean;
  isSuccess: boolean;
};

export function useWorkatoApps(): WorkatoHook {
  const { data, ...rest } = useSuspenseQuery(userWorkspaceQueryCreator());
  const workatoApps =
    // TODO(OTWEB-8950) Use `WorkspaceSettings` from @otter-ai/recall-client
    // when `workspace_connections` is added to the type
    (
      data?.workspace as unknown as {
        workspace_connections: { result: WorkatoApp[] };
      }
    )?.workspace_connections?.result ?? [];
  return { workatoApps, ...rest };
}
